import { useRef, type ReactNode } from 'react'
import { useClickOutside } from '@/hooks/useClickOutside'

interface DropdownProps {
    trigger: ReactNode
    children: ReactNode
    isOpen: boolean
    onClose: () => void
    align?: 'left' | 'right'
    className?: string
}

export function Dropdown({
    trigger,
    children,
    isOpen,
    onClose,
    align = 'left',
    className = '',
}: DropdownProps) {
    const dropdownRef = useRef<HTMLDivElement>(null)

    useClickOutside(dropdownRef, onClose, isOpen)

    const alignmentClass = align === 'right' ? 'right-0' : 'left-0'

    return (
        <div className="relative" ref={dropdownRef}>
            {trigger}
            {isOpen && (
                <div
                    className={`absolute top-full ${alignmentClass} mt-2 bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark rounded-xl shadow-xl animate-in fade-in zoom-in-95 duration-100 ${className}`}
                >
                    {children}
                </div>
            )}
        </div>
    )
}
